import { RouterState, RouterStore, HistoryAdapter } from 'mobx-state-router';
import { action, reaction, makeObservable } from 'mobx';
import { history, extendRouterStore } from 'common/utils';
import { AppStore } from 'common/stores';
import { AppPasswordRecoveryViewStore } from 'modules/membership/stores';
import { ApplicationStore } from 'common/stores';
import { baasicOptions } from 'common/infrastructure';
import { localStorageHandler } from 'core/services';
import {
	AuthStore,
	ErrorStore,
	LocalizationStore,
	NotificationStore,
	MainViewStore,
	MenuStore,
	UserSettingStore,
} from 'core/stores';

export default class RootStore {
	routerStore;
	appStore;
	authStore;
	errorStore;
	localizationStore;
	menuStore;
	baasicTableSettingsViewStore;
	notificationStore;
	appPasswordRecoveryViewStore;
	viewStore;
	usdFormatter;

	routerMaps;
	initialState = undefined;

	get app() {
		return this.applicationStore.app;
	}

	get organization() {
		return this.applicationStore.currentOrganization;
	}

	constructor() {
		makeObservable(this);
		this.applicationStore = new ApplicationStore(this);
		this.applicationStore.create(baasicOptions);
		this.applicationStore.setOrganization(localStorageHandler.get('lastOrganization'));
		this.errorStore = new ErrorStore(this);
		this.appStore = new AppStore(this);
		this.authStore = new AuthStore(this);
		this.localizationStore = new LocalizationStore(this);
		this.notificationStore = new NotificationStore(this);
		this.appPasswordRecoveryViewStore = new AppPasswordRecoveryViewStore(this);
		this.viewStore = new MainViewStore(this);
		this.menuStore = new MenuStore(this);
		this.userSettingStore = new UserSettingStore(this);
		this.usdFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		});
	}

	@action initializeRoutes({ routes, routerMaps }) {
		this.routerStore = makeObservable(new RouterStore(this, routes, new RouterState('master.not-found')));
		this.routerStore.routeHistory = [];
		this.routerMaps = routerMaps;
		this.historyAdapter = new HistoryAdapter(this.routerStore, history);
		this.historyAdapter.observeRouterStateChanges();

		const currentPath = this.historyAdapter.history.location.pathname;
		if (currentPath === '' || currentPath === '/') {
			this.routerStore.goTo('master.app.main.order.list');
		}

		reaction(
			() => this.routerStore.routerState,
			routerState => {
				this.routerStore.routeHistory.push(routerState);
				if (!this.routerInitialized) {
					this.routerInitialized = true;
				}
			}
		);

		extendRouterStore(this.routerStore, this.historyAdapter);
	}

	@action.bound initializeMenu(menu) {
		this.menuStore.setMenu(menu);
	}
}



// WEBPACK FOOTER //
// ./src/common/stores/RootStore.js